export enum Stepper {
  Client = 'client',
  JobDetails = 'job_details',
  AiAnalysis = 'ai_analysis',
  Review = 'review',
  Success = 'success'
}
